export default function formatDocument(phone) {
  const phoneAtualizado = phone.replace(/(\d{2})(\d{2})(\d{5})(\d{4})/,
    (regex, argumento1, argumento2, argumento3, argumento4) => `${argumento1} (${argumento2}) ${argumento3}-${argumento4}`);
  return phoneAtualizado;
}
